interface LogoProps {
  className?: string;
  size?: 'sm' | 'md' | 'lg' | 'xl';
  showText?: boolean;
  logoWidth?: string;
}

export function Logo({
  className = '',
  size = 'md',
  showText = true,
  logoWidth = 'w-7',
}: LogoProps): JSX.Element {
  const sizeClasses = {
    sm: 'h-6 w-12',
    md: 'h-8 w-16',
    lg: 'h-12 w-24',
    xl: 'h-16 w-32',
  };

  const textSizeClasses = {
    sm: 'text-lg',
    md: 'text-2xl',
    lg: 'text-4xl',
    xl: 'text-6xl',
  };

  return (
    <div className={`flex items-center justify-center gap-3 relative ${className}`}>
      {showText && (
        <h1 className={`font-bold ${textSizeClasses[size]} relative inline-flex items-center justify-center`}>
          <span className="text-blue-700">Retro</span>
          <img
            src="/retrojet_rounded.svg"
            alt="RetroJet Logo"
            className={`${sizeClasses[size].split(' ')[0]} ${logoWidth} relative z-10`}
            style={{ transform: 'translateX(15%) rotate(30deg)' }}
          />
          <span className="text-yellow-400 dark:text-yellow-400">Jet</span>
        </h1>
      )}
    </div>
  );
}
